import { memo } from 'react';
import { Circle, Marker, Polygon, Polyline } from 'react-leaflet';

import { center as turfCenter } from '@turf/center';
import { featureCollection, point } from '@turf/helpers';
import L from 'leaflet';

import { GEOMETRY_TYPE } from '../../constants/map';

import { FILL_OPACITY, LINE_WEIGHT } from '../../components/Maps/constants';

import MapPopup from './MapPopup';

const getIconMarker = color => {
  return new L.divIcon({
    html: `<span class="custom-marker" style="background: ${color}"/>`,
    className: 'marker',
    iconAnchor: [14, 22],
    labelAnchor: [-8, 0],
    popupAnchor: [0, -16]
  });
};

function MapSiteFeature(props) {
  const type = props.type;
  const color = props.color || '#fff';
  const fillColor = props.color || 'none';
  const fillOpacity = props.new || props.isSelected ? FILL_OPACITY.SELECTED : FILL_OPACITY.DEFAULT;
  const iconMarker = getIconMarker(props.color);

  let LINE;

  if (type === GEOMETRY_TYPE.POLYGON) {
    let coords = structuredClone(props.geometry);
    for (let coord in coords[0]) {
      let temp = coords[0][coord];
      let newc = [];
      newc[0] = temp[1];
      newc[1] = temp[0];
      coords[0][coord] = newc;
    }
    const features = featureCollection([
      point(coords[0][0]),
      point(coords[0][1]),
      point(coords[0][2]),
      point(coords[0][3])
    ]);
    const center = turfCenter(features);
    LINE = (
      <Polygon color={color} weight={LINE_WEIGHT} fillOpacity={fillOpacity} fillColor={fillColor} positions={coords}>
        <Marker icon={iconMarker} draggable={false} position={center.geometry.coordinates}>
          <MapPopup
            additionalData={props.properties.site_type}
            description={props.properties.description}
            link={`sites/${props.properties?.id}`}
            name={props.properties.name}
          />
        </Marker>
      </Polygon>
    );
  }
  if (type === GEOMETRY_TYPE.LINE) {
    LINE = <Polyline color={color} fillOpacity={fillOpacity} fillColor={fillColor} positions={props.geometry} />;
  }
  if (type === GEOMETRY_TYPE.POINT) {
    LINE = (
      <Circle
        center={[props.geometry[1], props.geometry[0]]}
        color={color}
        weight={LINE_WEIGHT}
        fillOpacity={fillOpacity}
        fillColor={fillColor}
        opacity="1"
        radius={!isNaN(props.properties.radius) ? props.properties?.radius : 1}>
        {' '}
        <Marker icon={iconMarker} draggable={false} position={[props.geometry[1], props.geometry[0]]}>
          <MapPopup
            additionalData={props.properties.site_type}
            description={props.properties.description}
            link={`sites/${props.properties?.id}`}
            name={props.properties.name}
          />
        </Marker>
      </Circle>
    );
  }
  return LINE;
}

export default memo(MapSiteFeature);
